var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('main-visual'), _c('main-section', {
    staticClass: "main-section--solution",
    attrs: {
      "title": "제품 및 솔루션",
      "titleClass": "text-center"
    }
  }, [_c('div', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-inline-block line-height-0 rounded overflow-hidden"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/main-solution-img.png",
      "alt": "이미지"
    }
  })])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "pl-lg-80"
  }, [_c('div', {
    staticClass: "tit-wrap mb-16"
  }, [_c('h2', {
    staticClass: "tit tit--md"
  }, [_vm._v("보안컨설팅")])]), _c('p', {
    staticClass: "font-size-16 font-size-md-22 grey-7--text"
  }, [_vm._v("최신 동향 및 법률을 반영한 컨설팅 방법론으로 최고의 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("정보보호 서비스를 제공합니다.")]), _c('div', {
    staticClass: "mt-40 mt-md-60"
  }, [_c('v-btn', {
    staticClass: "v-btn--none-active-bg pa-0 h-auto",
    attrs: {
      "to": "/business/consulting#consulting",
      "text": "",
      "color": "primary"
    }
  }, [_vm._v("더 알아보기"), _c('i', {
    staticClass: "icon icon-arrow-right-primary ml-12"
  })])], 1)])])], 1)], 1), _c('div', {
    staticClass: "mt-60 mt-md-80 mt-lg-110",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "order": "1",
      "order-md": "2"
    }
  }, [_c('div', {
    staticClass: "d-inline-block line-height-0 rounded overflow-hidden"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/main-solution-img2.png",
      "alt": "이미지"
    }
  })])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "order": "2",
      "order-md": "1"
    }
  }, [_c('div', {
    staticClass: "pl-lg-80"
  }, [_c('div', {
    staticClass: "tit-wrap mb-16"
  }, [_c('h2', {
    staticClass: "tit tit--md"
  }, [_vm._v("정보보안솔루션")])]), _c('p', {
    staticClass: "font-size-16 font-size-md-22 grey-7--text"
  }, [_vm._v("UWSS All in One SECaaS 솔루션 웹 해킹 예방, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("탐지, 대응을 하나의 웹보안 서비스(Unified Web "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("Security Service)를 제공합니다.")]), _c('div', {
    staticClass: "mt-40 mt-md-60"
  }, [_c('v-btn', {
    staticClass: "v-btn--none-active-bg pa-0 h-auto",
    attrs: {
      "to": "/solution/uwss#uwss",
      "text": "",
      "color": "primary"
    }
  }, [_vm._v("더 알아보기"), _c('i', {
    staticClass: "icon icon-arrow-right-primary ml-12"
  })])], 1)])])], 1)], 1)]), _c('main-section', {
    staticClass: "main-section--business",
    attrs: {
      "title": "사업분야",
      "titleClass": "text-center"
    }
  }, [_c('div', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('v-divider', {
    staticClass: "white",
    staticStyle: {
      "opacity": ".5"
    }
  }), _c('router-link', {
    staticClass: "main-business-con",
    attrs: {
      "to": "/business/consulting"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('i', {
    staticClass: "icon icon-num-01"
  })]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('div', {
    staticClass: "tit-wrap mb-12 mb-md-18"
  }, [_c('h2', {
    staticClass: "tit tit--sm"
  }, [_vm._v("컨설팅 사업")])]), _c('p', {
    staticClass: "font-size-16 font-size-md-18"
  }, [_vm._v("서비스는 고객의 정보자산을 각종 위협으로부터 안전하게 보호하기 위하여 Risk 관리를 기반으로 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("다양한 분야의 정보보안 컨설팅 서비스를 제공합니다.")])]), _c('v-col', {
    staticClass: "d-none d-md-block",
    attrs: {
      "cols": "12",
      "md": "1"
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "outlined": "",
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "icon icon-arrow-right-white"
  })])], 1)], 1)], 1)], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-divider', {
    staticClass: "white",
    staticStyle: {
      "opacity": ".5"
    }
  }), _c('router-link', {
    staticClass: "main-business-con",
    attrs: {
      "to": "/business/solution"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('i', {
    staticClass: "icon icon-num-02"
  })]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('div', {
    staticClass: "tit-wrap mb-12 mb-md-18"
  }, [_c('h2', {
    staticClass: "tit tit--sm"
  }, [_vm._v("솔루션 사업")])]), _c('p', {
    staticClass: "font-size-16 font-size-md-18"
  }, [_vm._v("UWSS, WMDS 등 소프트웨어 개발, 솔루션 영업을 주요업무로 하며, 제품의 설치 및 안내, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("A/S 서비스, 주기적인 업데이트 등 전반적인 사업을 담당합니다.")])]), _c('v-col', {
    staticClass: "d-none d-md-block",
    attrs: {
      "cols": "12",
      "md": "1"
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "outlined": "",
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "icon icon-arrow-right-white"
  })])], 1)], 1)], 1)], 1), _c('div', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('v-divider', {
    staticClass: "white",
    staticStyle: {
      "opacity": ".5"
    }
  }), _c('router-link', {
    staticClass: "main-business-con",
    attrs: {
      "to": "/business/blockchain"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('i', {
    staticClass: "icon icon-num-03"
  })]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('div', {
    staticClass: "tit-wrap mb-12 mb-md-18"
  }, [_c('h2', {
    staticClass: "tit tit--sm"
  }, [_vm._v("블록체인 사업")])]), _c('p', {
    staticClass: "font-size-16 font-size-md-18"
  }, [_vm._v("메타버스 플랫폼의 핵심 기술인 NFT, DID 관련 핵심기술을 개발합니다.")])]), _c('v-col', {
    staticClass: "d-none d-md-block",
    attrs: {
      "cols": "12",
      "md": "1"
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "outlined": "",
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "icon icon-arrow-right-white"
  })])], 1)], 1)], 1), _c('v-divider', {
    staticClass: "white",
    staticStyle: {
      "opacity": ".5"
    }
  })], 1)]), _c('main-section', {
    staticClass: "main-section--news",
    attrs: {
      "title": "NEWS"
    }
  }, [_c('template', {
    slot: "title-actions"
  }, [_c('div', {
    staticClass: "swiper-control"
  }, [_c('div', {
    staticClass: "swiper-prev"
  }, [_c('i', {
    staticClass: "icon icon-arrow-left"
  })]), _c('v-divider', {
    staticClass: "align-self-center mx-10",
    staticStyle: {
      "height": "16px"
    },
    attrs: {
      "vertical": ""
    }
  }), _c('div', {
    staticClass: "swiper-next"
  }, [_c('i', {
    staticClass: "icon icon-arrow-right"
  })])], 1)]), _c('main-news-slide')], 2), _c('popup-layer')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }